import React, {useCallback, useMemo} from "react";
import {HotlineNumber,} from "../typedefs";
import {Action, ActionSelect} from "../../../components/ui/ActionSelect";
import {useNavigateWithClientID} from "../hooks/useNavigateWithClientID";
import moment from "moment";
import {UserName} from "../../../components/data/UserName";
import {formatPhoneNumber} from "../../../lib/pnone/formatPhoneNumber";
import {useDeleteModal} from "../hooks/useDeleteModal";
import {usePermissions} from "../../../context/modulePermissions";

type HotlineNumberRowProps = {
    hotlineNumber: HotlineNumber;
    refetch: () => void;
}

export function HotlineNumberRow({hotlineNumber, refetch}: HotlineNumberRowProps) {

    const {navigateWithClientID} = useNavigateWithClientID()
    const {hasFullAccess} = usePermissions()

    const navigateToEdit = useCallback(() => {
        navigateWithClientID(`siren/hotline-numbers/${hotlineNumber.id}/edit`)
    },[navigateWithClientID, hotlineNumber.id])

    const phoneNumberFormatted = useMemo(() => {
        return formatPhoneNumber(hotlineNumber.phoneNumber.e164)
    }, [hotlineNumber])


    const {DeleteModal, openDeleteModal} = useDeleteModal(
        "Hotline Number",
        `${hotlineNumber.name} (${phoneNumberFormatted})`,
        `hotline-numbers/${hotlineNumber.id}`,
        refetch,
    )



    return (
        <>
            <DeleteModal/>
            <div className={"w-full"}>
                <div className="grid grid-cols-4 gap-8 w-full h-10">
                    <div className="truncate overflow-ellipsis items-center flex">
                        <a href="javascript:void(0)" onClick={navigateToEdit} className="flex items-center gap-4">
                            {hotlineNumber.name}
                        </a>
                    </div>

                    <div className="flex items-center">{phoneNumberFormatted}</div>
                    <div>
                        {hotlineNumber.inUse ? "Yes" : "No"}
                    </div> <div>
                        <ActionSelect label={"Actions"}>

                                <Action label="Edit"
                                        onSelect={navigateToEdit}
                                        hide={!hasFullAccess("siren_resources")}
                                />

                                <Action label="Delete"
                                        onSelect={openDeleteModal}
                                        hide={!hasFullAccess("siren_resources")}
                                />

                        </ActionSelect>

                    </div>
                </div>
            </div>
        </>

    )
}